import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    Button,
    Form,
    Input,
    Container,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    FormFeedback,
} from "reactstrap";

import { passwordRegex } from "Pages/Login/Login";
import useAlertContext from "Hooks/useAlertContext";
import styles from "Pages/Registration/ActivateUser.module.css";

export default function ResetPassword() {
    const [formData, setFormData] = useState({
        password: "",
        confirmPassword: "",
    });

    const params = new URLSearchParams(useLocation().search);
    const userId = params.get("user_id");
    let activationCode = params.get("activation_code");

    const navigate = useNavigate();
    const { newAlert } = useAlertContext();

    const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const newFormData = { ...formData, [name]: value };
        setFormData(newFormData);
    };

    async function setPassword(e: React.MouseEvent<HTMLButtonElement>) {
        const body = {
            user_id: userId,
            activation_code: activationCode,
            password: formData.password,
        };

        const response = await fetch(`/api/activate_user`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });

        let data: any;

        try {
            data = await response.json();
        } catch {
            data = response;
        }

        console.log(data);

        if (response.ok) {
            newAlert({
                message: "Password successfully reset.",
                color: "success",
            });
            navigate("/login");
        } else {
            newAlert({ message: "Unable to reset password.", color: "danger" });
        }
    }

    return (
        <Container>
            <Modal isOpen={true}>
                <ModalHeader>Choose a Password</ModalHeader>
                <ModalBody>
                    <Form className={styles.form}>
                        <Input
                            name="password"
                            value={formData.password}
                            onChange={(e) => handleFormChange(e)}
                            valid={
                                formData.password.length > 1 &&
                                passwordRegex.test(formData.password)
                            }
                            invalid={
                                formData.password.length > 1 &&
                                !passwordRegex.test(formData.password)
                            }
                            type="password"
                            placeholder="Password"
                            required
                        />
                        {formData.password.length > 1 && (
                            <FormFeedback>
                                Password must be at least eight characters long
                                and contain at least one number, one uppercase
                                letter and one lowercase letter
                            </FormFeedback>
                        )}
                        <Input
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={(e) => handleFormChange(e)}
                            valid={
                                formData.confirmPassword.length > 1 &&
                                formData.confirmPassword === formData.password
                            }
                            invalid={
                                formData.confirmPassword.length > 1 &&
                                formData.confirmPassword !== formData.password
                            }
                            type="password"
                            placeholder="Confirm Password"
                            required
                        />
                        {formData.password.length > 1 &&
                            passwordRegex.test(formData.password) &&
                            formData.confirmPassword.length > 1 && (
                                <FormFeedback>
                                    Passwords must match.
                                </FormFeedback>
                            )}
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className={styles.btn}
                        color="primary"
                        size="lg"
                        onClick={setPassword}
                        disabled={
                            !(
                                passwordRegex.test(formData.password) &&
                                formData.password === formData.confirmPassword
                            )
                        }
                    >
                        Reset
                    </Button>
                </ModalFooter>
            </Modal>

            {/* <h4>
                    Password must be at least eight characters long and contain
                    at least one number, one uppercase letter and one lowercase
                    letter.
                </h4> */}
        </Container>
    );
}
